(function (upp) {
    'use strict';

    upp.service('tripAdvisorService', ['appi', '$q',
        function (appi, $q) {
            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE;

            /**
             * Retrieves the rstaurant categories content. And store as a cache
             *
             * TODO: use http cache instead https://docs.angularjs.org/api/ng/service/$http
             * @method get
             * @return {Promise} Returns a promise that will be fulfilled(restaurant list content) or rejected(error)
             */
            var get = (function ($q, angular) {
                var cache = {}, _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();

                    if (cache.result) {
                        deferred.resolve(cache.result);
                    } else {
                        appi.http.get(URL_API_REST_SERVER + 'tripadvisor/')
                            .then(function (response) {
                                cache.result = _copy(response.data);
                                deferred.resolve(cache.result);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }

                    return deferred.promise;
                };
            }($q, angular));

            return {
                get: get
            };
        }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/tripadvisor/services/tripadvisor-services.js